import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersListComponent } from './users-list/users-list.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { SharedModule } from '../shared/shared/shared.module';
import { UserListComponent } from './shared/user-list/user-list.component';
import { UsersSharedModule } from './shared/users-shared.module';
import { EditUserModalComponent } from './shared/edit-user-modal/edit-user-modal.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    UsersSharedModule
  ],
  declarations: [
    UsersListComponent,
    UserDetailComponent,
  ],
  exports: [
    UserListComponent
  ]
})
export class UsersModule {
}



// WEBPACK FOOTER //
// ./src/app/users/users.module.ts